import ajax from "@/lib/ajax"
import { AbpApiResponse } from "@/store/models/common"
import { L } from "./BaseComponent"
import { Asdcom } from "./appservice.asdcom";


export class CommonService {

  async downloadPdfFile(submissionId: string) {
    // abp.log.debug({ getSubmissionPdf: { submmId: submissionId } })
    const token = await this.getTokenForPdf(submissionId);
    // Build file url.
    const fileUrl = `${asdcom.config.hostUrl}/api/services/app/VcpOnlineOkService/getPdfBinaryObjectByGuid?TempToken=Bearer ${token}`
    this.openPdfLink(fileUrl);
  }

  async openClaimPackagePdf(claimId: number) {
    const token = await this.getTokenForPdf(claimId);
    // Build file url.
    const fileUrl = `${asdcom.config.hostUrl}/api/services/app/VcpOnlineOkService/getClaimPdfFile?TempToken=Bearer ${token}`
    this.openPdfLink(fileUrl);
  }

  async openClaimLogPdf(claimId: number) {
    const token = await this.getTokenForPdf(claimId);
    // Build file url.
    const fileUrl = `${asdcom.config.hostUrl}/api/services/app/VcpOnlineOkService/getClaimLogsPdfFile?TempToken=Bearer ${token}`
    this.openPdfLink(fileUrl);
  }


  private async getTokenForPdf(pdfId: string | number): Promise<string> {
    const form = new FormData();
    form.append("claimId", String(pdfId));

    const tokenResp = await ajax.post<AbpApiResponse<string>>("/api/TokenAuth/GetTokenForHTTPGet", form)
    let retToken = tokenResp.data.result;
    if (retToken == undefined) {
      retToken = "";
      sweetAlert({ text: L("UnableToOpenPdf") });
    }
    return retToken;
  }

  private openPdfLink(fileUrl: string) {
    const url = fileUrl
    const link = document.createElement("a")
    link.href = url
    // link.target = "_blank"
    link.setAttribute("download", `.pdf`) //or any other extension
    document.body.appendChild(link)
    link.click()
  }
}